export default "__VITE_ASSET__DuPW4xhA__"